export default "__VITE_ASSET__BPNyIxnM__"